import { createReducer, on } from "@ngrx/store";
import { templateInstallationRequestsInitialState } from "../../initial-states/template-installation-requests.state";
import { addTemplateInstallationRequests, loadTemplateInstallationRequests, loadTemplateInstallationRequestsFailed, loadTemplateInstallationRequestsSuccess, upsertTemplateInstallationRequest, upsertTemplateInstallationRequestActivity, upsertTemplateInstallationRequests, upsertWorkflowExecutionStatus } from "../../actions/templates/template-installation-requests.actions";
import { ITemplateInstallationRequest, parseActivityStatus, parseInstallationRequestProperties } from "src/app/models/template-installation-requests.model";
import { parseFrontEndObjectProperties, WorkflowExecutionStatus } from "src/app/models/workflow-request.model";
import { ActivityLog, updateActivity } from "src/app/models/activity-logs/activity-logs.model";

export const TemplateInstallationRequestsReducer = createReducer(templateInstallationRequestsInitialState,
    // The reducer runs when a dispatch 'loadTemplateInstallationRequests' was triggered
    // The only thing we need to do here is set loading to true
    on(loadTemplateInstallationRequests,
        (state) => {
            return { ...state, loading: true };
        }
    ),

    // The reducer runs when a dispatch 'loadTemplateInstallationRequestsSuccess' was triggered
    // Here we need to set the loading to false, set the value of 'loadedOnce' and add the value of the workflows for the specific type
    on(loadTemplateInstallationRequestsSuccess,
        (state, { installationRequests }) => {
            return { ...state, loading: false, loadedOnce: true, value: installationRequests };
        }
    ),

    // The reducer runs when a dispatch 'loadTemplateInstallationRequestsFailed' was triggered
    // Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
    on(loadTemplateInstallationRequestsFailed,
        (state, { error }) => {
            return { ...state, loading: false, loadedOnce: false, error: error };
        }
    ),

     // The reducer runs when a dispatch 'addTemplateInstallationRequests' was triggered
    // Here we need to update an existing workflow in the store
    on(addTemplateInstallationRequests,
        (state, { requests }) => {
            return { ...state, value: addRequests(state.value, requests) };
        }
    ),

    // The reducer runs when a dispatch 'upsertTemplateInstallationRequest' was triggered
    // Here we need to update an existing workflow in the store
    on(upsertTemplateInstallationRequest,
        (state, { request }) => {
            return { ...state, value: updateRequestByReference(state.value, request) };
        }
    ),

    // The reducer runs when a dispatch 'upsertTemplateInstallationRequests' was triggered
    // Here we need to update an existing workflow in the store
    on(upsertTemplateInstallationRequests,
        (state, { requests }) => {
            return { ...state, value: updateRequestsByReference(state.value, requests) };
        }
    ),

    on(upsertWorkflowExecutionStatus,
        (state, { taskId, executionStatus }) => {
            return { ...state, value: updateExecutionStatus(state.value, taskId, executionStatus) };

        }
    ),

    on(upsertTemplateInstallationRequestActivity,
        (state, { activity }) => {
            const newState = { ...state };
			if (newState.value) {
				newState.value = AddOrUpdateListenerActivity(newState.value, activity);
			}
			return newState;
        }
    )

)

function updateRequestByReference(currentRequests: ITemplateInstallationRequest[], updatedRequest: ITemplateInstallationRequest): ITemplateInstallationRequest[] {
    const requestToUpdateIndex = currentRequests.findIndex(x => x.taskId === updatedRequest.taskId);
    const request = updatedRequest.type == 'WorkflowRequest' ? parseFrontEndObjectProperties(updatedRequest) : parseInstallationRequestProperties(updatedRequest)
    if (requestToUpdateIndex !== -1)
    {
        currentRequests[requestToUpdateIndex] = request
    }
    else
    {
        currentRequests.push(request);
    }

    return currentRequests;
}

function addRequests(currentRequests: ITemplateInstallationRequest[], newRequests: ITemplateInstallationRequest[]): ITemplateInstallationRequest[] {
    newRequests.forEach(request => {
        if (!currentRequests.find(r => r.taskId == request.taskId)){
            if (request.type == 'Request'){
                request = parseInstallationRequestProperties(request);
            }
            else {
                request = parseFrontEndObjectProperties(request)
            }
            currentRequests.push(request)
        }
    });

    return currentRequests;
}

function updateRequestsByReference(currentRequests: ITemplateInstallationRequest[], updatedRequests: ITemplateInstallationRequest[]): ITemplateInstallationRequest[] {
    updatedRequests.forEach(request => {
        currentRequests = updateRequestByReference(currentRequests, request);
    });

    return currentRequests;
}

function updateExecutionStatus(currentWorkflows: ITemplateInstallationRequest[], taskId: string, executionStatus: WorkflowExecutionStatus): ITemplateInstallationRequest[] {
    const workflowToUpdateIndex = currentWorkflows.findIndex(x => x.taskId === taskId);
    if (workflowToUpdateIndex > -1){
        currentWorkflows[workflowToUpdateIndex].executionStatus = executionStatus;
    } 
    return currentWorkflows;
}

function AddOrUpdateListenerActivity(currentState: ITemplateInstallationRequest[], activity: ActivityLog[]): ITemplateInstallationRequest[] {
    // for each activity that API send iteration to add and update activity
    activity.forEach(act => {
        // Find the index of the activity

        const request = currentState.find(x => x.taskId === act.general.taskId);
        if (request) {
            if (!request.activity) {
                request.activity = act;
            }
            request.activity = updateActivity(request.activity, act);

            if (act.general.locationTitle) {
                request.workspaceName = act.general.locationTitle;
                request.workspaceUrl = act.general.location;
            }

            request.executionStatus = parseActivityStatus(act.general.status);
        }
    });
    return currentState;
}
